import { render, staticRenderFns } from "./publicizeMaterialApplicationDetails.vue?vue&type=template&id=77c47f5b&scoped=true&"
import script from "./publicizeMaterialApplicationDetails.vue?vue&type=script&lang=js&"
export * from "./publicizeMaterialApplicationDetails.vue?vue&type=script&lang=js&"
import style0 from "./publicizeMaterialApplicationDetails.vue?vue&type=style&index=0&id=77c47f5b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c47f5b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77c47f5b')) {
      api.createRecord('77c47f5b', component.options)
    } else {
      api.reload('77c47f5b', component.options)
    }
    module.hot.accept("./publicizeMaterialApplicationDetails.vue?vue&type=template&id=77c47f5b&scoped=true&", function () {
      api.rerender('77c47f5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/publicizeMaterialManagement/publicizeMaterialApplicationDetails.vue"
export default component.exports